<template lang="pug">
  .form-group(v-if="!expiredLink")
    h2 Recuperação de senha

    PTextField(name="password" v-model="newPassword" type="password" autocomplete="off", label="nova senha")

    h5 A senha deve ter pelo menos 6 caracteres

    PButton(color="success" size="md" @click="applyForgotPassword", :disabled="!validPassword" block) Confirmar

  div(v-else="")
    h4 Esse link já foi utilizado ou está vencido.

    PButton(color="warning" size="md" @click="toForgotPassword" block) Enviar pedido novamente

</template>

<script>
import Auth from '@aws-amplify/auth'
import { configureCongito } from 'src/components/Cognito'

export default {
  props: {
    forgotPasswordData: {required: true, type: Object}
  },
  data () {
    return {
      newPassword: '',
      expiredLink: false
    }
  },
  computed: {
    validPassword () {
      return this.newPassword.length >= 6
    }
  },
  methods: {
    toForgotPassword () {
      this.$router.push('/cognito/forgotPassword')
    },
    async applyForgotPassword () {
      if (!this.validPassword) { return }

      try {
        const result = await this.$API.getAuthUserPool.save({email: this.forgotPasswordData.email})

        const { userPoolWebClientId, userPoolId } = result.data.success

        configureCongito({userPoolId, userPoolWebClientId})

        await Auth.forgotPasswordSubmit(this.forgotPasswordData.email, this.forgotPasswordData.code, this.newPassword)
        this.$swal({
          type: 'success',
          text: 'Senha alterada com sucesso'
        })
        window.location.href = window.location.origin + window.location.pathname
      } catch (e) {
        console.error('error', e)

        if (e.body) {
          this.$swal({
            type: 'error',
            text: 'Email inválido'
          })
          return
        }

        if (e.code === 'ExpiredCodeException') {
          this.expiredLink = true
          return
        }

        let feedbackMessage
        const message = e.message

        if (message === 'Password cannot be empty') {
          feedbackMessage = 'A nova senha não pode estar vazia'
        } else if (message.includes('Member must have length greater than or equal to 6')) {
          feedbackMessage = 'A nova senha deve ter no mínimo 6 caracteres'
        } else if (message.includes('Attempt limit exceeded')) {
          feedbackMessage = 'Limite de tentativas excedido. Por favor, tente novamente depois de algum tempo.'
        } else {
          feedbackMessage = 'Senha inválida, tente novamente'
        }

        this.$swal({
          type: 'error',
          text: feedbackMessage
        })
      }
    }
  }
}
</script>

<style scoped>
  .form-control {
    font-size: 18px;
    height: 50px;
  }

  .form-control, .control-label {
    width: 100%;
  }
  .confirm {
    width: 100%;
    height: 50px;
  }
</style>
